export { default } from './DashboardMenuWrapper';
export { default as DashboardMenu } from './DashboardMenuWrapper';
